/*
 * @Author: Jhonsem
 * @Date: 2021-01-06 12:01:06
 * @Last Modified by: Jhonsem
 * @Last Modified time: 2021-01-06 14:10:57
 * 1.launchParams
 * 2.deviceInfo
 * 3.store从native_storage restore
 */

import Jsbridge from "@/jsbridge/index";
import { store } from "@/main";

class LaunchDataHelpers {
  public launchData!: any;

  constructor() {
    this.launchData = new Map();
  }

  public init() {
    return new Promise((resolveFinally, rejectFinally) => {
      Promise.all([
        this.launchParamsPromise(),
        // this.deviceInfoPromise(),
        this.storeRestoredPromise() // restored from native_storage
      ])
        .then(([launchParams]) => {
          // const launchDataSet = {
          //   launchParams,
          //   deviceInfo
          // };
          // this.setLaunchData(launchParams);
          this.launchData = launchParams;
          resolveFinally(launchParams);
        })
        .catch((error: any) => {
          console.log("error:", error);
          rejectFinally(error);
        });
    });
  }

  public storeRestoredPromise() {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await (store as any).restored;
        resolve(res);
      } catch (error) {
        reject(error);
      }
    });
  }

  public launchParamsPromise() {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await Jsbridge.launchParams();
        resolve(res);
      } catch (error) {
        reject(error);
      }
    });
  }

  // public deviceInfoPromise() {
  //   return new Promise(async (resolve, reject) => {
  //     try {
  //       const res = await Jsbridge.deviceInfo();
  //       resolve(res);
  //     } catch (error) {
  //       reject(error);
  //     }
  //   });
  // }

  // public setLaunchData(params: any) {
  //   for (const key of Object.keys(params)) {
  //     this.launchData.set(key, params[key]);
  //   }
  // }

  public getLaunchData() {
    return this.launchData;
  }
}

export default new LaunchDataHelpers();
